var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"my-3"},[_c('ListHeader',{attrs:{"text":"配料","value":"extras"}}),_c('ListTable',{attrs:{"value":"extras","items":_vm.extras,"fields":_vm.fields},on:{"remove":_vm.removeExtra}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }